import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ApplicationUserService } from 'src/app/infrastructure/services/application-user.services/application-user.service';

type TConfirmState = 'confirming' | 'confirmed' | 'failed' | 'missingParams';

@Component({
    selector: 'confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: true,
    imports: [
        MatButtonModule,
        RouterLink,
    ],
})
export class ConfirmComponent implements OnInit {

    private __state$$ = signal<TConfirmState>('confirming');
    state$$ = this.__state$$.asReadonly();

    constructor(
        private __route: ActivatedRoute,
        private __authService: AuthService,
        private __applicationUserService: ApplicationUserService,
    ) { }

    ngOnInit(): void {
        const email = this.__route.snapshot.queryParams.email;
        const newEmail = this.__route.snapshot.queryParams.newEmail;
        const code = this.__route.snapshot.queryParams.code;

        if (!email || !code) {
            this.__state$$.set('missingParams');
            return;
        }

        const confirm$ = newEmail
            ? this.__authService.postConfirmEmailChange$(email, newEmail, code)
            : this.__authService.postConfirm$(email, code);

        confirm$.subscribe({
            next: () => {
                this.__state$$.set('confirmed');
                // Alleen zichtbaar effect als de link in hetzelfde, nog ingelogde tabblad wordt
                // geopend (het gangbare geval bij een zelf-geïnitieerde wijziging); in een ander of
                // uitgelogd tabblad is dit een onschadelijke no-op.
                if (newEmail) this.__applicationUserService.accountEmail_refresh();
            },
            error: () => this.__state$$.set('failed'),
        });
    }

}
